import { useState, useEffect } from "react";
import { Row, Card, Tabs, Tab, Col } from 'react-bootstrap';
import { Globe } from 'react-bootstrap-icons';
import InvoiceDetailHeader from "./InvoiceDetailHeader";
import "./Invoice.scss"
import InvoiceDetailPaymentList from "./InvoiceDetailPaymentList";
import InvoiceDetailMedia from "./InvoiceDetailMedia";
import TaskList from "./TaskList";
import axios from "axios";
import WebService from "../utility/WebService";
import HelperService from "../utility/HelperService";
import Header from "../Header/Header";
import InvoiceDetailQuote from "./InvoiceDetailQuote";
import stopIcon from "../../src/assets/images/stop.svg";
import InvoiceDetailEquiment from "./InvoiceDetailEquiment";
import InvoiceDetailRecommendation from "./InvoiceDetailRecommendation";
import phoneIcon from '../assets/images/phone.svg';
import mailIcon from '../assets/images/mail.svg';
import InvoiceDetailAuthorizeWork from "./InvoiceDetailAuthorizationWork";
import InvoiceDetailTechnician from "./InvoiceDetailTechnician";
import { toast } from "react-toastify";
import invoiceImage from '../assets/images/OnInvoice.jpg';
import Loader from "../Loader/Loader";
import Footer from "../Footer/Footer";
import InvoiceDetail from "./InvoiceDetail";
import InvoiceInfo from "./InvoiceInfo";
import InvoiceQuote from "./InvoiceQuote";
import InvoiceDetailEquipmentChecklist from "./InvoiceDetailEquipmentChecklist";
import TermsCondition from "./TermsCondition";

interface PropData {
    isPayment?: boolean
    isReceipt?: boolean
}

const Invoice = (props: PropData) => {
    const [isLoading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState<any>({});
    const [companyCode, setCompanyCode] = useState<any>();
    const [invoiceNum, setInvoiceNum] = useState<any>();
    const [isShowInvoice, setIsShowInvoice] = useState(false)
    const [otherData, setOtherData] = useState<any>()
    const [id, setId] = useState<any>()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = encodeURIComponent(urlParams.get('token') || "");
    const [isShowTermsModel, setShowTermsModel] = useState(false);
    const [isShowReason, setIsShowReason] = useState(false);
    const [refreshPaymentTab, setRefreshPaymentTab] = useState(false);

    useEffect(() => {
        if (value) {
            setId(value)
            getAccessToken()
        } else {
            setId('')
        }
    }, [])

    const handlePaymentDone = () => {
        setRefreshPaymentTab(prev => !prev); // toggle to force refresh
    };
    const getAccessToken = () => {
        localStorage.clear();
        setLoading(true)
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken?id=${value}`)
            .then((res: any) => {
                setLoading(false)
                if (res.data.status == 'Error') {
                    toast.error(res.data.message)
                    setIsShowInvoice(false)
                }
                if (res.data.accessToken) {
                    setOtherData(res.data)
                    getInvoiceData(res.data.accessToken, res.data.companyCode, res.data.invoiceNumber, res.data.tenantUrl)
                    setInvoiceNum(res.data.invoiceNumber)
                    setCompanyCode(res.data.companyCode)
                    setIsShowReason(res.data.showInvoiceReason)
                    localStorage.setItem('token', res.data.accessToken)
                    localStorage.setItem('tenant_url', res.data.tenantUrl)
                }
            })
            .catch((e) => {
                setId('')
                setIsShowInvoice(false)
                setLoading(false);
            })
    };

    const getInvoiceData = (token: string, code: string, invoice: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        setLoading(true)
        const value = props.isReceipt ?
            `${url}/api/Invoice/customerReceiptInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=true`
            :
            `${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=true`
        axios.get(value, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    getMoreData(token, code, invoice, url)
                    setIsShowInvoice(true)
                    res.data.data.callInfo.invoiceNum = invoice;
                    setInvoiceData(res.data.data);
                }
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getMoreData = (token: string, code: string, invoice: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        const value =
            // props.isReceipt ?
            //     `${url}/api/Invoice/customerReceiptInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=false`
            //     :
            `${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=false`
        axios.get(value, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    setIsShowInvoice(true)
                    res.data.data.callInfo.invoiceNum = invoice;
                    setInvoiceData(res.data.data);
                }
            })
            .catch((e) => {
            });
    };

    const onTerms = () => {
        setLoading(true)
        WebService.getAPI({
            action: `api/Invoice/terms/${otherData?.companyCode}`
        })
            .then((res: any) => {
                if (res.pdfUrl) {
                    window.open(res.pdfUrl)
                } else {
                    setShowTermsModel(true)
                }
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    const onDownload = (code: string, invoiceNum: string) => {
        setLoading(true);
    
        const url = `${WebService.getUrl()}api/Reports/GetServiceInvoicePDF?CompanyCode=${code}&InvoiceNum=${invoiceNum}`;
    
        axios.get(url, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then((res) => {
            const blob = new Blob([res.data], { type: 'application/pdf' });
    
            // Use FileSaver.js for cross-browser support OR use this native way:
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = 'Invoice.pdf'; // Forces "Save As"
            link.style.display = 'none';
    
            document.body.appendChild(link);
            link.click();
    
            // Cleanup
            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(link);
    
            setLoading(false);
        })
        .catch((e) => {
            console.error("Download failed", e);
            setLoading(false);
        });
    }


    return <>
        <div>
            <Loader show={isLoading} />
            {otherData?.companyCode && <TermsCondition
                isShow={isShowTermsModel}
                isClose={() => setShowTermsModel(false)}
                data={otherData?.companyCode}
            />}
            {!props.isPayment && <Header data={invoiceData} code={companyCode} invoice={invoiceNum} receipt={props.isReceipt} onTermsClick={() => onTerms()} onDownloadClick={() => onDownload(companyCode, invoiceNum)}/>}
            {
                isShowInvoice &&
                <div className='p-2' style={{ backgroundColor: "#E0E0E0" }}>

                    {
                        !props.isPayment &&
                        <Card className="content-card card-shadow p-0 ">
                            <Card.Body className="py-2 text-dark">
                                <Row className="mb-3 pt-1">
                                    {
                                        otherData?.genericLogoUrl &&
                                        <Col md={3} >
                                            <img src={otherData?.genericLogoUrl} width="80%" height={130} style={{ objectFit: 'contain', marginLeft: '2%', padding: 0 }} />
                                        </Col>
                                    }
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Company Info</div>
                                        {
                                            invoiceData?.companyInfo?.companyName && <div className="address-text">{invoiceData?.companyInfo?.companyName}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.companyAddr1 && <div className="address-text">{invoiceData?.companyInfo?.companyAddr1}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.companyAddr2 && <div className="address-text">{invoiceData?.companyInfo?.companyAddr2}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.companyCity && <div className="address-text">{invoiceData?.companyInfo?.companyCity} {invoiceData?.companyInfo?.companyState && ', ' + invoiceData?.companyInfo?.companyState} {invoiceData?.companyInfo?.companyZip && ", " + invoiceData?.companyInfo?.companyZip}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.compPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(invoiceData?.companyInfo?.compPhone)}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.compEmail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {invoiceData?.companyInfo?.compEmail}</div>
                                        }
                                        {
                                            invoiceData?.companyInfo?.compWebAddress && <div className="address-text">
                                                <Globe className="me-2" />
                                                {invoiceData?.companyInfo?.compWebAddress}</div>
                                        }
                                    </Col>
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Bill To {invoiceData?.billTo?.billTo}
                                            {invoiceData?.billTo?.acctOnCreditHold == true && <img src={stopIcon} className="ms-2 mb-1" />}</div>
                                        {
                                            invoiceData?.billTo?.custName && <div className="address-text">{invoiceData?.billTo?.custName}</div>
                                        }
                                        {
                                            invoiceData?.billTo?.custAddress1 && <div className="address-text">{invoiceData?.billTo?.custAddress1}</div>
                                        }
                                        {
                                            invoiceData?.billTo?.custAddress2 && <div className="address-text">{invoiceData?.billTo?.custAddress2}</div>
                                        }
                                        {
                                            invoiceData?.billTo?.custCity && <div className="address-text">{invoiceData?.billTo?.custCity} {invoiceData?.billTo?.custState && ', ' + invoiceData?.billTo?.custState} {invoiceData?.billTo?.custZip && ", " + invoiceData?.billTo?.custZip}</div>
                                        }
                                        {
                                            invoiceData?.billTo?.customerPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(invoiceData?.billTo?.customerPhone)}</div>
                                        }
                                        {
                                            invoiceData?.billTo?.custEmail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {invoiceData?.billTo?.custEmail}</div>
                                        }
                                    </Col>
                                    <Col md={3}>
                                        <div className="mb-0 font-w-medium font-15">Location {invoiceData?.location?.smNum}</div>
                                        {
                                            invoiceData?.location?.smName && <div className="address-text">{invoiceData?.location?.smName}</div>
                                        }
                                        {
                                            invoiceData?.location?.address1 && <div className="address-text">{invoiceData?.location?.address1}</div>
                                        }
                                        {
                                            invoiceData?.location?.address2 && <div className="address-text">{invoiceData?.location?.address2}</div>
                                        }
                                        {
                                            invoiceData?.location?.city && <div className="address-text">{invoiceData?.location?.city} {invoiceData?.location?.state && ', ' + invoiceData?.location?.state} {invoiceData?.location?.zip && ", " + invoiceData?.location?.zip}</div>
                                        }
                                        {
                                            invoiceData?.location?.smPhone && <div className="address-text">
                                                <img src={phoneIcon} className="me-2" />
                                                {HelperService.getFormattedContact(invoiceData?.location?.smPhone)}</div>
                                        }
                                        {
                                            invoiceData?.location?.defaultEMail && <div className="address-text">
                                                <img src={mailIcon} className="me-2" />
                                                {invoiceData?.location?.defaultEMail}</div>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    }
                    {
                        !props.isPayment && isShowReason &&
                        <Card className="content-card card-shadow p-0 mt-2">
                            <Card.Body className="py-2 text-dark">
                                <p className="mb-0 font-w-medium font-14">Call For Reason</p>
                                <p className="font-14 mb-0">{invoiceData?.callInfo?.reasonForCall ? invoiceData?.callInfo?.reasonForCall : '-'}</p>
                            </Card.Body>
                        </Card>
                    }
                    {!props.isPayment && <InvoiceDetailHeader InvoiceData={invoiceData} showLoader={isLoading} receipt={props.isReceipt} code={companyCode} payment={props.isPayment} onPaymentDone={handlePaymentDone}/>}

                    {
                        !props.isPayment && invoiceData && invoiceData?.menuItems && invoiceData?.menuItems.length > 0 && !HelperService.isEmptyObject(invoiceData) &&
                        <div className="p-1 tab-style-2 invoicedetail-tabs">
                            <Tabs defaultActiveKey={invoiceData.menuItems[0].menuCode} className=" mt-1">
                                {
                                    invoiceData.menuItems.length > 0 && invoiceData.menuItems.map((res: any) => {

                                        return (
                                            <Tab eventKey={res.menuCode}  key={res.menuCode} 
                                                title={
                                                    <div className="d-flex flex-column justify-content-center align-items-center tab-name">
                                                        <label className="nav-text">{res.displayName}</label>
                                                    </div>
                                                }

                                            >
                                                {res.menuCode == 'Invoiceinfo' && <InvoiceInfo data={invoiceData} />}
                                                {res.menuCode == 'Tasklist' && <TaskList data={invoiceData} code={companyCode} token={value ?? ''} />}
                                                {res.menuCode == 'QuoteDetail' && <InvoiceDetailQuote header={invoiceData?.quoteDetailHeader} data={invoiceData?.quoteDetail} />}
                                                {res.menuCode == 'Quote' && <InvoiceQuote data={invoiceData} />}
                                                {(res.menuCode == 'Paymentinfo' || res.menuCode == 'PaymentInfo') && <InvoiceDetailPaymentList data={invoiceData} code={companyCode} payment={props.isPayment}  refreshTrigger={refreshPaymentTab}/>}
                                                {res.menuCode == 'Recommendations' && <InvoiceDetailRecommendation data={invoiceData} />}
                                                {res.menuCode == 'Equipment' && <InvoiceDetailEquiment data={invoiceData} code={companyCode} otherData={otherData} />}
                                                {res.menuCode == 'Technicians' && <InvoiceDetailTechnician data={invoiceData} />}
                                                {res.menuCode == 'AuthorizeWork' && <InvoiceDetailAuthorizeWork data={invoiceData} />}
                                                {res.menuCode == 'Media' && <InvoiceDetailMedia data={invoiceData?.mediaFiles} />}
                                                {res.menuCode == 'InvoiceDetail' && <InvoiceDetail header={invoiceData?.invoiceDetailHeader} data={invoiceData?.invoiceDetail} />}
                                                {/* <InvoiceDetailEquipmentChecklist data={invoiceData} code={companyCode} token={value ?? ''}/> */}
                                            </Tab>
                                        )
                                    })
                                }
                                {/* <Tab eventKey={'Eq'}
                                    title={
                                        <div className="d-flex flex-column justify-content-center align-items-center tab-name">
                                            <label className="nav-text">Equipment Tasklist</label>
                                        </div>
                                    }

                                >
                                    <InvoiceDetailEquipmentChecklist data={invoiceData} code={companyCode} token={value ?? ''}/>
                                </Tab> */}
                            </Tabs>
                        </div>
                    }

                </div>
            }
            {
                props.isPayment && invoiceData && invoiceData?.menuItems && <InvoiceDetailPaymentList data={invoiceData} code={companyCode} payment={props.isPayment} refreshTrigger={refreshPaymentTab} />
            }
            {
                isShowInvoice == false && id == '' &&
                <div className="no-invoice-view">
                    <img src={invoiceImage} height={200} width={200} />
                    <span className="no-invoice">No Invoice Found!</span>
                </div>
            }
            {!props.isPayment && <Footer data={otherData?.genericFooter} />}
        </div>
    </>;
};

export default Invoice;


